import { z } from 'zod';
/**
 * Alertas do Monitor: o líder escolhe o que quer ser avisado, e a partir de quando.
 *
 * As regras são **pessoais e por setor**. Pessoais porque quem acompanha a operação não é
 * sempre o supervisor — em alguns setores é um apoio N2 —, e cada um tem o próprio limite
 * de paciência. Por setor porque o mesmo problema incomoda em ritmos diferentes: cinco
 * minutos sem resposta no Suporte é normal, na Liberação pode já ser um técnico parado no
 * poste esperando.
 *
 * Alerta não é acusação nem erro: é "vá olhar isso".
 */
export const TIPOS_ALERTA = [
    'sem_resposta',
    'fila_espera',
    'fila_sem_atendente',
    'pausa_longa',
    'ausente_longo',
    'no_limite',
];
export const ALERTAS = {
    sem_resposta: {
        rotulo: 'Atendente sem responder o cliente',
        ajuda: 'O cliente falou e ninguém respondeu desde então.',
        padraoMinutos: 5,
        unidade: 'minutos sem resposta',
    },
    fila_espera: {
        rotulo: 'Cliente esperando na fila',
        ajuda: 'Ninguém pegou o atendimento ainda.',
        padraoMinutos: 10,
        unidade: 'minutos na fila',
    },
    fila_sem_atendente: {
        rotulo: 'Fila parada sem ninguém disponível',
        ajuda: 'Tem gente esperando, o setor está no horário e não há atendente disponível.',
        padraoMinutos: 5,
        unidade: 'minutos assim',
    },
    pausa_longa: {
        rotulo: 'Em pausa há muito tempo',
        ajuda: 'Cada motivo de pausa tem o seu tempo; o motivo vem junto no alerta.',
        padraoMinutos: 30,
        unidade: 'minutos de pausa',
    },
    ausente_longo: {
        rotulo: 'Ausente há muito tempo',
        ajuda: 'Dentro do horário do setor. É o caso de quem abriu o painel e não ficou disponível.',
        padraoMinutos: 20,
        unidade: 'minutos ausente',
    },
    no_limite: {
        rotulo: 'Atendente no limite',
        ajuda: 'Está com o máximo de conversas simultâneas. Sinal de redistribuir.',
        padraoMinutos: 10,
        unidade: 'minutos no limite',
    },
};
/**
 * Tipos que se desdobram por recorte — hoje, só a pausa.
 *
 * "Em pausa há muito tempo" com um número só obrigava a escolher entre avisar tarde no
 * banheiro e incomodar todo almoço (relato de 30/09). Com o motivo na regra, cada pausa
 * tem o seu tempo: 10 minutos de banheiro, 70 de almoço, e a regra sem motivo cobre o
 * resto.
 */
export function aceitaMotivo(tipo) {
    return tipo === 'pausa_longa';
}
/** Minutos: menos de 1 não é alerta, é ruído; mais de um dia não chega a disparar. */
export const regraAlertaFormSchema = z.object({
    setorId: z.uuid('Escolha o setor'),
    tipo: z.enum(TIPOS_ALERTA),
    /** Vazio é a regra geral; qualquer outro valor é o motivo exato da pausa. */
    motivo: z.string().trim().max(60).default(''),
    minutos: z.coerce.number().int().min(1, 'Mínimo de 1 minuto').max(1440, 'Máximo de 24 horas'),
    ativa: z.boolean().default(true),
});
/** Silenciar: o líder já foi verificar e não quer ver o mesmo aviso agora. */
export const silenciarAlertaSchema = z.object({
    minutos: z.coerce.number().int().min(5).max(480).default(30),
});
//# sourceMappingURL=alertas.js.map